(() => {
  const style = document.createElement('style');
  style.textContent = `
    @media screen and (max-width: 749px) {
      .menu-drawer__navigation > .menu-drawer__menu > .menu-drawer__list-item--flat {
        position: relative;
        margin-block-end: 0;
      }

      .menu-drawer__navigation .menu-drawer__list-item--divider,
      .menu-drawer__navigation .menu-drawer__menu-container--divider {
        border-block-end: 0 !important;
      }

      .menu-drawer__menu-item--mainlist {
        min-height: 48px;
        padding-block: 10px;
        padding-inline-end: 8px;
        font-size: 18px;
        line-height: 1.25;
      }

      .vc-drawer-parent > .menu-drawer__menu-item--mainlist {
        padding-inline-end: 52px;
      }

      .menu-drawer__menu-item--child {
        min-height: 38px;
        padding-block: 8px;
        padding-inline-start: 16px;
        font-size: 15px;
        line-height: 1.3;
      }

      .vc-drawer-toggle {
        position: absolute;
        inset-block-start: 0;
        inset-inline-end: 0;
        width: 48px;
        height: 48px;
        display: grid;
        place-items: center;
        padding: 0;
        border: 0;
        background: transparent;
        color: currentColor;
        cursor: pointer;
      }

      .vc-drawer-toggle::before,
      .vc-drawer-toggle::after {
        content: '';
        position: absolute;
        width: 14px;
        height: 1.5px;
        background: currentColor;
        transition: transform 180ms ease;
      }

      .vc-drawer-toggle::after {
        transform: rotate(90deg);
      }

      .vc-drawer-toggle[aria-expanded='true']::after {
        transform: rotate(0deg);
      }

      .vc-drawer-parent > .menu-drawer__menu--childlist {
        margin: 0;
        padding-block: 2px 8px;
      }

      .vc-drawer-parent > .menu-drawer__menu--childlist[hidden] {
        display: none !important;
      }

      .menu-drawer-container[open]
        .menu-drawer__navigation
        .menu-drawer__animated-element {
        animation: none !important;
        visibility: visible;
        opacity: 1;
        transform: none;
      }

      .menu-drawer-container[open]
        .vc-drawer-parent
        > .menu-drawer__menu--childlist
        .menu-drawer__animated-element {
        animation: none !important;
        visibility: visible;
        opacity: 1;
        transform: none;
      }
    }
  `;
  document.head.appendChild(style);

  const setupDrawer = (root = document) => {
    const parents = root.querySelectorAll('.menu-drawer__navigation > .menu-drawer__menu > li');

    parents.forEach((item, index) => {
      const childList = item.querySelector(':scope > .menu-drawer__menu--childlist');
      const parentLink = item.querySelector(':scope > .menu-drawer__menu-item--mainlist');
      if (!childList || !parentLink || item.classList.contains('vc-drawer-parent')) return;

      const label = parentLink.textContent.trim();
      const childListId = `VCMobileSubmenu-${index}-${Math.random().toString(36).slice(2, 8)}`;
      const toggle = document.createElement('button');

      item.classList.add('vc-drawer-parent');
      childList.id = childListId;
      childList.hidden = true;

      toggle.type = 'button';
      toggle.className = 'vc-drawer-toggle';
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-controls', childListId);
      toggle.setAttribute('aria-label', `Expand ${label} submenu`);

      toggle.addEventListener('click', () => {
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!expanded));
        toggle.setAttribute('aria-label', `${expanded ? 'Expand' : 'Collapse'} ${label} submenu`);
        childList.hidden = expanded;
      });

      item.appendChild(toggle);
    });
  };

  const initialize = () => {
    setupDrawer();

    const headerGroup = document.getElementById('header-group');
    if (!headerGroup) return;

    let refreshQueued = false;
    const observer = new MutationObserver(() => {
      if (refreshQueued) return;
      refreshQueued = true;
      requestAnimationFrame(() => {
        setupDrawer(headerGroup);
        refreshQueued = false;
      });
    });

    observer.observe(headerGroup, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => setupDrawer(event.target));
})();
